import "./styled.css";
import { getDic } from "../../assets/i18n/dictionary";

import imgSecurity from "../../assets/images/image_2.webp";
import imgCap from "../../assets/images/image_3.webp";
import imgSunglasses from "../../assets/images/image_4.webp";
import imgLightbulb from "../../assets/images/image_5.webp";
import imgScroll from "../../assets/images/image_6.webp";
import imgCameraLens from "../../assets/images/image_7.webp";
import imgPhone from "../../assets/images/image_8.webp";
import imgFaceScanBlue from "../../assets/images/image_9.webp";
import imgFaceScanGreen from "../../assets/images/image_10.webp";
import imgExampleWrong1 from "../../assets/images/image_11.webp";
import imgExampleWrong2 from "../../assets/images/image_12.webp";
import imgExampleWrong3 from "../../assets/images/image_13.webp";
import imgExampleCorrect from "../../assets/images/image_14.webp";

export default function InfoPhoto({ configOptions, lightenHex, setStep }) {
  return (
    <div className="div-card info-photo-card" style={{
      background: lightenHex(configOptions.backgroundColor, 20),
      color: configOptions.textColor
    }}>
      <button
        className="button-takePhoto-green"
        style={{
          marginBottom: 20,
          background: configOptions.buttonBackgroundColor,
          color: configOptions.buttonTextColor,
        }}
        onClick={() => setStep(2)}
      >
        📷 {getDic("tirar-foto").toUpperCase()}
      </button>

      <div className="info-header-box" style={{
        background: lightenHex(configOptions.backgroundColor, 40),
        color: configOptions.textColor
      }}>
        <img src={imgSecurity} alt="" className="info-header-icon" />
        <span className="info-header-text" style={{
          color: configOptions.textColor
        }}>
          {getDic(
            "foto-usada-para-identificacao",
          )}
        </span>
      </div>

      <p className="info-section-title" style={{
        color: configOptions.textColor
      }}>
        {getDic("siga-orientacoes")}
      </p>

      <div className="info-grid">
        <div className="info-tile" style={{
          background: lightenHex(configOptions.backgroundColor, 40)
        }}>
          <img src={imgCap} alt="" className="info-tile-img" />
          <span style={{
            color: configOptions.textColor
          }}>
            {getDic("nao-use-bones-chapeus")}
          </span>
        </div>
        <div className="info-tile" style={{
          background: lightenHex(configOptions.backgroundColor, 40)
        }}>
          <img src={imgSunglasses} alt="" className="info-tile-img" />
          <span style={{
            color: configOptions.textColor
          }}>{getDic("nao-use-oculos-escuros")}</span>
        </div>
        <div className="info-tile" style={{
          background: lightenHex(configOptions.backgroundColor, 40)
        }}>
          <img src={imgLightbulb} alt="" className="info-tile-img" />
          <span style={{
            color: configOptions.textColor
          }}>
            {getDic("ambiente-bem-iluminado")}
          </span>
        </div>
        <div className="info-tile" style={{
          background: lightenHex(configOptions.backgroundColor, 40)
        }}>
          <img src={imgScroll} alt="" className="info-tile-img" />
          <span style={{
            color: configOptions.textColor
          }}>{getDic("utilize-fundo-neutro")}</span>
        </div>
      </div>

      <div className="tips-strip" style={{
        background: lightenHex(configOptions.backgroundColor, 40)
      }}>
        <div className="tip-item" style={{
          background: lightenHex(configOptions.backgroundColor, 40)
        }}>
          <img src={imgCameraLens} alt="" />
          <span style={{ color: configOptions.textColor }}>{getDic("limpe-a-lente")}</span>
        </div>
        <div className="tip-item" style={{
          background: lightenHex(configOptions.backgroundColor, 40)
        }}>
          <img src={imgPhone} alt="" />
          <span style={{ color: configOptions.textColor }}>{getDic("segure-celular-firme")}</span>
        </div>
        <div className="tip-item" style={{
          background: lightenHex(configOptions.backgroundColor, 40)
        }}>
          <img src={imgFaceScanBlue} alt="" />
          <span style={{ color: configOptions.textColor }}>{getDic("olhe-diretamente-para-camera")}</span>
        </div>
        <div className="tip-item" style={{
          background: lightenHex(configOptions.backgroundColor, 40)
        }}>
          <img src={imgFaceScanGreen} alt="" />
          <span style={{ color: configOptions.textColor }}>{getDic("mantenha-rosto-visivel")}</span>
        </div>
      </div>

      <div className="examples-section">
        <p className="examples-title" style={{ color: configOptions.textColor }}>{getDic("exemplos-de-foto")}</p>
        <div className="examples-grid">
          <div className="examples-box" style={{
            background: lightenHex(configOptions.backgroundColor, 40)
          }}>
            <span className="examples-badge">❌</span>
            <div className="examples-photos-row">
              <img src={imgExampleWrong1} alt="" className="examples-photo" />
              <img src={imgExampleWrong2} alt="" className="examples-photo" />
              <img src={imgExampleWrong3} alt="" className="examples-photo" />
            </div>
            <span className="examples-label" style={{ color: configOptions.textColor }}>
              {getDic("exemplos-incorretos")}
            </span>
            <span className="examples-desc" style={{ color: configOptions.textColor }}>
              {getDic("rosto-coberto")}
            </span>
          </div>
          <div className="examples-box" style={{
            background: lightenHex(configOptions.backgroundColor, 40)
          }}>
            <span className="examples-badge">✅</span>
            <img
              src={imgExampleCorrect}
              alt=""
              className="examples-photo-single"
            />
            <span className="examples-label" style={{ color: configOptions.textColor }}>{getDic("exemplo-correto")}</span>
            <span className="examples-desc" style={{ color: configOptions.textColor }}>
              {getDic("rosto-centralizado")}
            </span>
          </div>
        </div>
      </div>

      <button
        className="button-takePhoto-green"
        style={{
          marginBottom: 20,
          background: configOptions.buttonBackgroundColor,
          color: configOptions.buttonTextColor,
        }}
        onClick={() => setStep(2)}
      >
        📷 {getDic("tirar-foto").toUpperCase()}
      </button>

      <div className="info-footer-box">
        <img src={imgSecurity} alt="" className="info-footer-icon" />
        <span style={{ color: lightenHex(configOptions.textColor) }}>
          {getDic("fotos-seguras")}
        </span>
      </div>
    </div>
  );
}
